<div class="flex align-items-center justify-content-center font-bold m-2 text-3xl title-case">
    Topcon Configuration
</div>
<p-card>
    <!-- <div class="flex align-items-center justify-content-center font-bold text-3xl -mt-4">
        Topcon Configuration
    </div> -->
    <div class="loading-error-wrapper" *ngIf="showLoadingErrorMessage()">
        <div>
            <span>Unable to load partner's configuration.</span>
            <span>{{loadingError}}</span>
        </div>
        <button
                pButton
                label="Refresh"
                (click)="onRefreshClicked()"
        ></button>
    </div>
    <div class="wrapper" *ngIf="!showLoadingErrorMessage()">
        <div class="partner-selection-wrapper flex align-items-center justify-content-center font-bold">
            <label for="partnerId" class="required-field">Partner ID :</label>
            <p-dropdown 
                [options]="partners"
                optionLabel="partnerId"
                optionValue="partnerId"
                [(ngModel)]="selectedPartnerId"
                [autoDisplayFirst]="false"
                placeholder="Select Partner ID"
                [filter]="true"
                (onChange)="onSelectedPartnerIdChanged()"></p-dropdown>
            <input 
                type="text" 
                pInputText
                [value]="this.selectedPartner.partnerName"
                disabled>
        </div>
        <p-card styleClass="setting-content" *ngIf="!selectedPartner.isDefault()">
            <div class="limit-setting-wrapper">
                <span class="limit-setting-title">UCM Resend Limitations (per Unit)</span>
                <div>
                    <label for="partnerId">Maximum Number of Resends :</label>
                    <p-inputNumber
                        inputId="withoutgrouping" 
                        [useGrouping]="false"
                        [ngClass]= "{'showerrorBorder' : (this.selectedPartner.maximumResendLimit === null || this.selectedPartner.maximumResendLimit < 0 || this.selectedPartner.maximumResendLimit > 1000)}"
                        [(ngModel)]="this.selectedPartner.maximumResendLimit">
                    </p-inputNumber>
                    <span>per :</span>
                    <p-dropdown 
                        [options]="frequencyLimitUnitsForResend"
                        [(ngModel)]="this.selectedPartner.maximumResendLimitUnit"></p-dropdown>
                </div>
                <span class="error-message" *ngIf="this.selectedPartner.maximumResendLimit > 1000">
                    Number Of Resend should have 1000 as maximum
                </span>
                <span class="error-message" *ngIf="this.selectedPartner.maximumResendLimit < 0">
                    Number Of Resend should be positive integer
                </span>
                <span class="error-message" *ngIf="this.selectedPartner.maximumResendLimit === null">
                    Number Of Resend is required
                </span>
            </div>
            <div class="limit-setting-wrapper">
                <span class="limit-setting-title">Test Activation Limitations (per Unit)</span>
                <div>
                    <label for="partnerId">Maximum Number of Test Activations :</label>
                    <p-inputNumber
                        inputId="withoutgrouping" 
                        [useGrouping]="false"
                        [ngClass]= "{'showerrorBorder' : (this.selectedPartner.maximumTestActivationLimit === null || this.selectedPartner.maximumTestActivationLimit < 0 || this.selectedPartner.maximumTestActivationLimit > 1000)}"
                        [(ngModel)]="this.selectedPartner.maximumTestActivationLimit"></p-inputNumber>
                    <span>per :</span>
                    <p-dropdown 
                        [options]="frequencyLimitUnits"
                        [(ngModel)]="this.selectedPartner.maximumTestActivationLimitUnit"></p-dropdown>
                </div>
                <span class="error-message" *ngIf="this.selectedPartner.maximumTestActivationLimit > 1000">
                    Number Of Test Activation should have 1000 as maximum
                </span>
                <span class="error-message" *ngIf="this.selectedPartner.maximumTestActivationLimit < 0">
                    Test Activation should be positive integer
                </span>
                <span class="error-message" *ngIf="this.selectedPartner.maximumTestActivationLimit === null">
                    Test Activation is required
                </span>
            </div>
            <div class="limit-setting-buttons-wrapper">
                <button
                    pButton
                    label="Update limitations"
                    [disabled]="disableSaveLimitationsButton()"
                    (click)="onUpdatingPartnerSettingClicked()"
                    ></button>
            </div>
        </p-card>
        <p-card styleClass="setting-content"  *ngIf="!selectedPartner.isDefault()">
            <div>
                <div class="table-header-wrapper">
                    <span class="limit-setting-title">Service Offerings</span>
                    <div>
                        <button pButton label="Add Service Level Configuration"
                            (click)="onAddNewServiceLevelConfigurationClicked()"></button>
                        <button pButton label="Reset Password" (click)="onUpdatePasswordClicked()"></button>
                    </div>
                </div>
                <div>
                    <span *ngIf="configurationGroups.length < 1">
                        No Configuration Data Available
                    </span>
                    <p-table #tblServiceLevelConfigs *ngIf="configurationGroups.length > 0" [value]="configurationGroups" responsiveLayout="scroll" [paginator]="true" [rows]="4" [showCurrentPageReport]="true">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Service Level</th>
                                <th>Market Sector</th>
                                <th>Geogating Mode</th>
                                <th>Product Code</th>
                                <th>Geogating Type</th>
                                <th>Allowable Durations</th>
                                <th>Allowable Coverage Levels</th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-editing="editing" let-group let-ri="rowIndex">
                            <tr *ngFor="let pair of group.getGroupingData(); first as isFirst; last as isLast" [ngClass]="{'last-row': isLast}">
                                <ng-container *ngIf="isFirst">
                                    <td class="grouped-col no-border" [rowSpan]="group.getGroupingData().length">{{group.serviceLevelName}}</td>
                                    <td [ngClass]="{'no-border': isLast && isFirst}">{{pair.marketSector}}</td>
                                    <td [ngClass]="{'no-border': isLast && isFirst}">{{pair.geogatingMode}}</td>
                                    <td [ngClass]="{'no-border': isLast && isFirst}">{{pair.productCode}}</td>
                                    <td [ngClass]="{'no-border': isLast && isFirst}">{{pair.geogatingType}}</td>
                                    <td class="column-max-width no-border" [rowSpan]="group.getGroupingData().length">{{group.getDurationsAsString()}}</td>
                                    <td [rowSpan]="group.getGroupingData().length" class="no-border">{{group.getCoverageLevelsAsString()}}</td>
                                    <td [rowSpan]="group.getGroupingData().length" class="no-border">
                                        <div class="buttons-column">
                                            <div class="buttons-wrapper">
                                                <button 
                                                    pButton pRipple 
                                                    type="button" 
                                                    icon="pi pi-pencil" 
                                                    pInitEditableRow
                                                    (click)="onRowEditClicked(group)" 
                                                    class="p-button-rounded">
                                                </button>
                                                <button 
                                                    pButton pRipple 
                                                    type="button" 
                                                    icon="pi pi-trash" 
                                                    pCancelEditableRow
                                                    (click)="onRowDeleteClicked(group)"
                                                    class="p-button-rounded p-button-danger">
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container *ngIf="!isFirst">
                                    <td [ngClass]="{'no-border': isLast}">{{pair.marketSector}}</td>
                                    <td [ngClass]="{'no-border': isLast}">{{pair.geogatingMode}}</td>
                                    <td [ngClass]="{'no-border': isLast}">{{pair.productCode}}</td>
                                    <td [ngClass]="{'no-border': isLast}">{{pair.geogatingType}}</td>
                                </ng-container>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-card>
        <p-card styleClass="setting-content" *ngIf="!selectedPartner.isDefault()">
            <div class="">
                <div class="compact-table-wrapper">
                    <div class="table-header-wrapper">
                        <span class="limit-setting-title">Test Activation Mapping</span>
                        <button
                            pButton
                            label="Add Test Activation Mapping"
                            (click)="onAddTestActivationMappingClicked()"
                            ></button>
                    </div>
                    <span *ngIf="testActivationConfigs.length < 1">
                        No Configuration Data Available
                    </span>
                    <p-table 
                        *ngIf="testActivationConfigs.length > 0"
                        dataKey="testActivationConfigId"
                        #tblTestActivationConfig 
                        editMode="row" 
                        [value]="testActivationConfigs" 
                        responsiveLayout="scroll" 
                        [paginator]="true" 
                        [rows]="5" 
                        [showCurrentPageReport]="true"
                        class="compact-table">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Access Code</th>
                                <th>Product Code</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-config let-ri="rowIndex">
                            <tr [pEditableRow]="config">
                                <td style="width: 120px;">
                                    <span *ngIf="currentEditingTestActivationConfig === config.testActivationConfigId">
                                        <p-dropdown 
                                            appendTo="body" 
                                            [options]="accessCodes" 
                                            [(ngModel)]="config.accessCodeId" 
                                            optionLabel="name" 
                                            optionValue="id"></p-dropdown>
                                    </span>
                                    <span *ngIf="currentEditingTestActivationConfig !== config.testActivationConfigId">
                                        {{config.accessCodeName}}
                                    </span>
                                </td>
                                <td style="width: auto">
                                    <span *ngIf="currentEditingTestActivationConfig === config.testActivationConfigId">
                                        <p-inputMask
                                            mask="9999-99-9"
                                            class="table-input"
                                            [(ngModel)]="config.productCode"></p-inputMask>
                                    </span>
                                    <span *ngIf="currentEditingTestActivationConfig !== config.testActivationConfigId">
                                        {{config.productCode}}
                                    </span>
                                </td>
                                <td style="width: 40px;">
                                    <div class="buttons-column">
                                        <button 
                                            *ngIf="currentEditingTestActivationConfig !== config.testActivationConfigId" 
                                            pButton 
                                            pRipple 
                                            type="button" 
                                            pInitEditableRow 
                                            icon="pi pi-pencil" 
                                            (click)="onTestActivationRowEditInit(config)" 
                                            class="p-button-rounded"></button>
                                        <button 
                                            *ngIf="currentEditingTestActivationConfig === config.testActivationConfigId" 
                                            pButton 
                                            pRipple 
                                            type="button" 
                                            pSaveEditableRow 
                                            icon="pi pi-check" 
                                            (click)="onTestActivationRowEditSave(config)" 
                                            class="p-button-rounded p-button-text p-button-success mr-2"></button>
                                        <button 
                                            *ngIf="currentEditingTestActivationConfig === config.testActivationConfigId" 
                                            pButton 
                                            pRipple 
                                            type="button" 
                                            pCancelEditableRow 
                                            icon="pi pi-times" 
                                            (click)="onTestActivationRowEditCancel(config, ri)" 
                                            class="p-button-rounded p-button-text p-button-danger"></button>
                                    </div>
                                </td>
                                <td style="width: 40px;">
                                    <div class="buttons-column">
                                        <button 
                                            pButton pRipple 
                                            type="button" 
                                            icon="pi pi-trash" 
                                            (click)="onTestActivationRowDeleteClicked(config)"
                                            class="p-button-rounded p-button-danger"></button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-card>
    </div>
</p-card>
<p-toast styleClass="custom-toast" life="10000" position="top-center"></p-toast>
<p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>